var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('headTitle',{attrs:{"title":"修改手机号"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('img',{attrs:{"src":require("@/assets/images/icon-change-phone-success.png"),"alt":""}}),_c('span',[_vm._v("修改成功")])])
}]

export { render, staticRenderFns }